import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';

import { Table } from '../../../../components/table';
import { AssessmentsModal } from '../../../../components/modal';
import { getColumns } from './table/getColumns';

import {
    fetchMPLessonsSingleND
} from '../../../../actions-nd';

const defaultSorted = { dataField: 'date_taken', order: 'desc' };

function AssessmentsTable(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const { assessments, refreshData, searchTerm } = props;

    const [loading, setLoading] = useState(false);
    const [modalMode, setModalMode] = useState(null);
    const [selectedAssessment, setSelectedAssessment] = useState(null);

    const handleShowModal = useCallback((mode, assessment) => {
        if(mounted.current){
            setModalMode(mode);
            setSelectedAssessment(assessment);
        }
    }, [mounted]);
    const onSubmitCallback = useCallback((changes = false) => {
        if(mounted.current){
            setModalMode(null);
            setSelectedAssessment(null);
            if(changes) refreshData(searchTerm);
        }
    }, [mounted, refreshData, searchTerm]);
    const downloadFile = useCallback((fileInfo, type, options) => {
        fileInfo.type = type;
        fileInfo.options = options;
        (async function doDownload(){
            if(loading) return;
            if(mounted.current) setLoading(true);
            await fetchMPLessonsSingleND(fileInfo);
            if(mounted.current) setLoading(false);
        })();
    }, [loading, setLoading]);
    const columns = useMemo(() => {
        return getColumns(handleShowModal, downloadFile);
    }, [handleShowModal, downloadFile]);

    return (
        <div>
            {modalMode &&
                <AssessmentsModal
                    mode={modalMode}
                    selectedAssessment={selectedAssessment}
                    onSubmitCallback={onSubmitCallback}
                />
            }
            <Table
                tableName="assessments"
                data={assessments}
                columns={columns}
                defaultSorted={defaultSorted}
                sizePerPageInitial={50}
                emptyMessage="No assessments were found"
            />
        </div>
    );
}

export default connect(null, {

})(AssessmentsTable);